import { KeyValueObject } from "@/UI/Interfaces/IBaseUI";
import { get, post } from "@/Utils/axios";

export function requestGetDocumentHelp(helpobjectno: string, helpwhere: string, processcode: string, filter: KeyValueObject): any {
  return post(`Configuration/GetDocumentHelp`, { helpobjectno, helpwhere, processcode, filter });
}

export function requestGetLoadHelpData(helpobjectno: string, helpwhere: string, helpTags: KeyValueObject, processcode: string, filterObject: KeyValueObject): any {
  return post(`Configuration/GetLoadHelpData`, { helpobjectno, helpwhere, helpTags, processcode, filter: filterObject });
}

export function LoadHelpObject(helpobjectno: string, helpwhere: string, processcode: string, helpTags: any, filterObject: KeyValueObject = {}): any {
  return post(`Configuration/LoadHelpObject`, { helpobjectno, helpwhere, processcode, helpTags, filter: filterObject });
}

export function LoadHelpObjectTags(helpobjectno: string, helpWhere: string): any {
  return get(`Configuration/LoadHelpObjectTags`, { params: { helpobjectno, helpWhere } });
}